import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepDateSchema = z.object({
    // @ts-ignore
    dob: z.string().min(1, { message: i18n.t('dob_required') }).nullable(),
});

export type RegistrationStepDateType = z.infer<typeof registrationStepDateSchema>;
